module.exports = __webpack_public_path__ + "static/media/IMG20191115154947.632b7a35.jpg";